import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Head from 'next/head';

import { ContextProvider } from '@/context/index';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../styles/globals.css';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const [key, setKey] = useState('home');
  useEffect(() => {
    if (router.asPath) {
      const k = router.asPath.split('?')[0];
      setKey(k[1]);
    }

    if (window?.history?.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
  }, [router.asPath]);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>

      <ContextProvider>
        <ParallaxProvider>
          <Component {...pageProps} />
        </ParallaxProvider>
      </ContextProvider>
    </>
  );
}

export default MyApp;
